import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Colors from '../colors';
import Text from '../text';
const StyledSnackbar = styled.Pressable`
  flex-direction: row;
  background-color: ${Colors.gray600};
  padding: 12px 16px;
  border-radius: 4px;
  box-shadow: 0px 1px 15px rgba(61, 79, 92, 0.15);
  margin-top: 20px;
  width: 328px;
  max-width: 328px;
`;
export default function Snackbar(props) {
  return /*#__PURE__*/React.createElement(StyledSnackbar, {
    onPress: () => {
      var _props$hideOnPress;

      (_props$hideOnPress = props.hideOnPress) === null || _props$hideOnPress === void 0 ? void 0 : _props$hideOnPress.call(props, props.id);
      props.onPress();
    }
  }, /*#__PURE__*/React.createElement(Text.BodyBase, {
    weight: "regular",
    color: Colors.white,
    align: "center"
  }, props.message));
}
Snackbar.defaultProps = {
  id: '',
  message: '',
  hideOnPress: undefined,
  onPress: () => null
};
Snackbar.propTypes = {
  id: PropTypes.string,
  message: PropTypes.string,
  hideOnPress: PropTypes.func,
  onPress: PropTypes.func
};
//# sourceMappingURL=snackbar.js.map